<template>
  <div
    ref="filter"
    id="filter"
    class="modal modal-right fade modal-more-filters"
    tabindex="-1"
    role="dialog"
    aria-labelledby="filter"
  >
    <div class="modal-dialog" role="document" style="width: 360px;">
      <div class="modal-content" ref="section">
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("More Filters") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div
              class="card-header header-elements-inline border-0 shadow-none p-0"
            >
              <div
                @click="toggleOption('productType')"
                name="productType"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-productType"
              >
                <div>{{ $t("Product Type") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="[
                        'list-icons-item',
                        { 'rotate-180': options.productType }
                      ]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-productType"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{ 'mb-0': !productTypeList.length }"
                >
                  <div
                    class="form-check"
                    v-for="type in productTypeList"
                    :key="type"
                  >
                    <div>
                      <label class="form-check-label">
                        <div class="uniform-choice">
                          <span
                            :class="[
                              dataFilter.product_type.includes(type)
                                ? 'checked'
                                : ''
                            ]"
                          >
                            <input
                              type="radio"
                              :value="type"
                              :id="'type-' + type"
                              v-model="dataFilter.product_type"
                              @change="filterChange()"
                            />
                          </span>
                        </div>
                        {{ $t(type) }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('productType')"
                    >{{ $t("Clear") }}</a
                  >
                </div>
              </div>
            </div>

            <div class="card card-collapsed border-0 shadow-none mb-0">
              <div
                class="card-header header-elements-inline border-0 shadow-none p-0"
              >
                <div
                  id="stockStatusCollapse"
                  name="stockStatus"
                  @click="toggleOption('stockStatus')"
                  aria-expanded="false"
                  class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                  data-toggle="collapse"
                  data-target="#collapse-stockStatus"
                  data-test="filter-stock-status"
                >
                  <div>{{ $t("Stock Status") }}</div>
                  <div class="header-elements">
                    <div class="list-icons">
                      <a
                        :class="[
                          'list-icons-item',
                          { 'rotate-180': options.stockStatus }
                        ]"
                        data-action="collapse"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="collapse ui-filter-list card-body"
                id="collapse-stockStatus"
              >
                <div
                  class="filter-option"
                  style="margin: 0 15px;"
                  data-test="option-stock-status"
                >
                  <div
                    class="form-check"
                    v-for="statusLists in stockStatusList"
                    :key="statusLists"
                  >
                    <label class="form-check-label">
                      <div class="uniform-checker ">
                        <span
                          :class="[
                            dataFilter.stock_status.includes(statusLists)
                              ? 'checked'
                              : ''
                          ]"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="statusLists"
                            :id="'status-' + statusLists"
                            v-model="dataFilter.stock_status"
                            @change="filterChange()"
                          />
                        </span>
                      </div>
                      {{ mapLowerCase(statusLists) }}
                    </label>
                  </div>
                </div>
                <div class="clear ml-2 mt-3">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="dataFilter.stock_status = ''"
                    data-test="btn-clear-filter-stock-status"
                    >{{ $t("Clear") }}</a
                  >
                </div>
              </div>
            </div>

            <div class="card card-collapsed border-0 shadow-none mb-0">
              <div
                class="card-header header-elements-inline border-0 shadow-none p-0"
              >
                <div
                  id="warehouseCollapse"
                  @click="toggleOption('warehouse')"
                  aria-expanded="false"
                  class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                  data-toggle="collapse"
                  data-target="#collapse-warehouse"
                  data-test="filter-warehouse"
                >
                  <div>{{ $t("Warehouse") }}</div>
                  <div class="header-elements">
                    <div class="list-icons">
                      <a
                        :class="[
                          'list-icons-item',
                          { 'rotate-180': '' }
                        ]"
                        data-action="collapse"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="collapse ui-filter-list card-body px-4"
                id="collapse-warehouse"
              >
                <div class="filter-option">
                  <div
                    class="form-group form-group-feedback form-group-feedback-right"
                  >
                    <div
                      id="select-warehouse-search"
                      data-test="select-warehouse"
                    >
                      <MultiSelect
                        id="select-warehouse"
                        name="warehouse-filter"
                        :options="myOptions"
                        @changeMultiSelect="onMultiSelectShippingOptions"
                        select-all-text="All"
                        :non-selected-text="this.$t('Select warehouse....')"
                        :enable-html="true"
                        :has-optgroup="false"
                        :checkbox-multiselect-all="true"
                        :enable-case-insensitive-filtering="true"
                        :disabled="myOptions.length == 0 ? true : false"
                        :active-option="dataFilter.warehouse_ids"
                        :filter-placeholder="this.$t('Search')"
                        @resetMutiSelectOptions="resetMutiSelectOptions"
                        :reset-mutiselect="resetMutiselect"
                      />
                    </div>
                  </div>
                  <div class="clear">
                    <a
                      href="javascript:void(0)"
                      class="text-secondary"
                      @click="
                        [(dataFilter.warehouse_ids = []), (resetMutiselect = true)]
                      "
                      data-test="btn-clear-filter-warehouse"
                      >{{ $t("Clear") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3"
        >
          <button
            type="button"
            class="btn btn-light"
            @click="clearFilter('all')"
          >
            {{ $t("Clear all filters") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="doneFilter()"
            data-dismiss="modal"
          >
            {{ $t("Done") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Api from "@/services/endpoint/tenant.service";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import MultiSelect from '@/plugins/MultiSelect.vue'

export default {
  name: "FilterMore",
  components: {
    MultiSelect
  },
  props: {
    filter: {
      type: [Object, Array],
      default: undefined
    }
  },
  data() {
    let vm = this;
    return {
      options: {
        warehouse: false,
        stockStatus: false,
        productType: false
      },
      dataFilter: initialFilter(),
      myOptions: [],
      resetMutiselect: false,
      warehouseList: this.$parent.filtersMore.warehouses,
      stockStatusList: this.$parent.filtersMore.stock_status,
      productTypeList: this.$parent.filtersMore.product_type,
      // productTypeList: [
      //   {
      //     id: "1",
      //     name: this.$t("simple")
      //   },
      //   {
      //     id: "2",
      //     name: this.$t("linked")
      //   }
      // ]
    };
  },
  async mounted() {
    $(this.$refs.filter).on("shown.bs.modal", () => {
       for (let warehouse of this.warehouseList) {
        warehouse.text = warehouse.name;
      }
        this.myOptions = this.warehouseList;
    });
  },
  computed: {},
  methods: {
    mapLowerCase(val) {
      const str = val;
      let words = str
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      if (words === "In Stock") {
        words = "_inventory.In Stock";
      } else if (words === "In Active") words = "Inactive";
      return this.$t(words);
    },
    toggleOption(key) {
      if (key == "warehouse") {
        this.options.warehouse
          ? (this.options.warehouse = false)
          : (this.options.warehouse = true);
      } else if (key == "stockStatus") {
        this.options.stockStatus
          ? (this.options.stockStatus = false)
          : (this.options.stockStatus = true);
      } else if (key == "productType") {
        this.options.productType
          ? (this.options.productType = false)
          : (this.options.productType = true);
      }
    },
    clearFilter(key) {
      if (key == "warehouse") {
        this.dataFilter.type = [];
      } else if (key == "stockStatus") {
        this.dataFilter.stock_status = [];
      } else if (key == "productType") {
        this.dataFilter.product_type = [];
      } else if (key == "all") {
        this.dataFilter = initialFilter();
        this.resetMutiselect = true;
      }
    },
    filterChange() {},
    doneFilter() {
      // let stockStatus = this.dataFilter.stockStatus ? 1 : 0;
      let stockStatus = this.dataFilter.stock_status.length;
      let productType = this.dataFilter.product_type ? 1 : 0;
      let warehouse = this.dataFilter.warehouse_ids.length;
      this.$parent.countFilter = stockStatus +  warehouse + productType;

      this.$parent.filterinfo(this.dataFilter);
    },
    myChangeEvent(val) {
    },
    mySelectEvent({ id, text, color, name }) {
    },
    onMultiSelectShippingOptions(event) {
      this.dataFilter.warehouse_ids = event;
    },
    resetMutiSelectOptions(data){
      this.resetMutiselect = data;
    },
  }
};

function initialFilter() {
  return {
    product_type: "",
    stock_status: [],
    warehouse_ids: []
  };
}
</script>

<style>
.suggest-item.hover #salesStaff .text-danger {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/inventory/FiltersMoreInventory.vue